module.exports = __webpack_public_path__ + "img/vk.503bb463.svg";